var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectBankAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 438.03 304.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1uui1121,.cls-2uui1121,.cls-3uui1121,.cls-4uui1121{fill:none;}.cls-1uui1121,.cls-5uui1121,.cls-6uui1121{stroke-width:0px;}.cls-2uui1121{stroke-dasharray:0 0 0 6;stroke-width:2px;}.cls-2uui1121,.cls-3uui1121{stroke-linecap:round;}.cls-2uui1121,.cls-3uui1121,.cls-4uui1121{stroke-miterlimit:10;}.cls-2uui1121,.cls-4uui1121{stroke:#004f68;}.cls-3uui1121{stroke:#009ed9;stroke-dasharray:0 0 0 8;stroke-width:3px;}.cls-5uui1121{fill:#e1e8e7;}.cls-6uui1121{fill:#009ed9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1uui1121",
    width: 438.03,
    height: 304.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5uui1121",
    points: "220.89 44.03 105.92 93.8 105.92 115.52 335.87 115.52 335.87 93.8 220.89 44.03"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4uui1121",
    points: "335.87 93.8 220.89 44.03 105.92 93.8"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2uui1121",
    cx: 220.89,
    cy: 83.42,
    r: 18.24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5uui1121",
    points: "146.1 218.74 119.79 218.74 123.05 115.52 142.83 115.52 146.1 218.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5uui1121",
    points: "190.08 218.74 163.78 218.74 167.04 115.52 186.82 115.52 190.08 218.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5uui1121",
    points: "278.05 218.74 251.74 218.74 255 115.52 274.79 115.52 278.05 218.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5uui1121",
    points: "322.03 218.74 295.73 218.74 298.99 115.52 318.77 115.52 322.03 218.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5uui1121",
    points: "234.06 218.74 207.76 218.74 211.02 115.52 230.8 115.52 234.06 218.74"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5uui1121",
    x: 105.86,
    y: 218.74,
    width: 230,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5uui1121",
    x: 87.21,
    y: 247.04,
    width: 267.32,
    height: 28.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4uui1121",
    x1: 105.86,
    y1: 247.04,
    x2: 335.87,
    y2: 247.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4uui1121",
    x1: 117.48,
    y1: 218.74,
    x2: 324.25,
    y2: 218.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3uui1121",
    d: "m322.03,71.32c34.69.59,58.11,7.84,61.37,21.38,6.13,25.5-61.61,63.64-151.3,85.2-89.69,21.56-167.36,18.37-173.49-7.13-2.17-9.03,4.92-19.64,18.97-30.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6uui1121",
    points: "80.31 147.66 86.35 133.98 71.48 135.58 80.31 147.66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectBankAccounts);
export default __webpack_public_path__ + "static/media/connect-bank-accounts.f95297a16294ad5a8c98180d17ba6702.svg";
export { ForwardRef as ReactComponent };